import { create } from 'zustand';
import { ThemeColors } from '../../core/types/ThemeModel';
import { ThemeName } from '../../themes/themes';


interface ThemeState {
  theme: ThemeName;
  colors: ThemeColors | null;
  setTheme: (theme: ThemeName) => void;
  setColors: (colors: ThemeColors) => void;
  resetTheme: () => void;
}

const getStoredTheme = (): ThemeName => {
  return (localStorage.getItem("theme") as ThemeName) || "light";
};

const getStoredColors = (): ThemeColors | null => {
  const stored = localStorage.getItem("colors");
  return stored ? JSON.parse(stored) : null;
};

export const useThemeStore = create<ThemeState>((set) => ({
  theme: getStoredTheme(),
  colors: getStoredColors(),
  setTheme: (theme) => {
    localStorage.setItem('theme', theme);
    set({ theme });
  },
  setColors: (colors) => {
    localStorage.setItem('colors', JSON.stringify(colors));
    set({ colors })
  },
   resetTheme: () => {
    localStorage.removeItem("theme");
    localStorage.removeItem("colors");
    set({ theme: "light", colors: null });
  }
}));
